//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: [],
    data () {
        return {
            dialogVisible: false,
            form: {
                pwd: '',
                newmobile: '',
                checknewmobile: ''
            }
        }
    },
    computed: {
        chechnewmobileRules() {
            var rule = this.newRule('确认新手机号', 'required');
            rule.push({
                validator: this.checkPwd,
                trigger: 'blur'
            });
            return rule;
        }
    },
    methods: {
        show() {
            this.dialogVisible = true;
        },
        close() {
            this.dialogVisible = false;
        },
        checkPwd(rule, value, callback) {
            if (value === '') {
                callback(new Error('请再次输入手机号'));
            } else if (value !== this.form.newmobile) {
                callback(new Error('两次输入手机号不一致!'));
            } else {
                callback();
            }
        },
        submit: function(){
            this.$post(sysUrl+'/user/changemoblie', this.form, (data, res) => {
                ShowMsg(res.msg, 'success', ()  =>  {
                    this.close();
                })
            })
        }
    },
    mounted: function() {

    }
}
